module.exports = __webpack_public_path__ + "static/dir1-9503e4845c9f0c90051a1375494863f1.png";